import { AuthProvider } from "./hooks/useAuth";
import { SidebarProvider } from "./context/SidebarContext";
import { OverlaySidebarProvider } from "./context/OverlaySidebarContext";

export const AppProviders = ({ children }) => {
  return (
    <AuthProvider>
      <OverlaySidebarProvider>
        <SidebarProvider>
          {/* Add more providers here */}
          {children}
        </SidebarProvider>
      </OverlaySidebarProvider>
    </AuthProvider>
  );
};
